'use client';

import { useMemo } from 'react';

import { ApiSchemas } from '@/components/providers/v1-api';
import { useEmployeeById } from '@/components/providers/v1-office-hooks';

type Route = ApiSchemas['RouteReadComplete'];

export function RouteSummary({ route }: { route: Route }) {
  const employee = useEmployeeById(route.employee_id);
  const serviceEventCount = useMemo(
    () =>
      route.events.filter(
        (e) => !!e.service_event && e.service_event.status !== 'CANCELLED' && e.service_event.status !== 'RESCHEDULED'
      ).length,
    [route.events]
  );
  return (
    <div className='flex items-center justify-between rounded-md border p-3'>
      <div className='flex flex-col'>
        <div className='text-sm font-medium'>{employee ? `${employee.first_name} ${employee.last_name}` : ''}</div>
        <div className='text-muted-foreground text-xs'>{serviceEventCount} appointments</div>
      </div>
    </div>
  );
}
